import { UseFormSetError, FieldValues, Path } from 'react-hook-form';
import { ApiClientError } from 'api/client';

/**
 * Puts a Laravel 422's errors on the form fields that `fields` maps them to
 * (request key → form field; `ids.3` falls back to `ids`). Returns false when
 * any error has no field, so the caller still shows it as a toast.
 */
export function applyLaravelErrors<T extends FieldValues>(
  err: unknown,
  setError: UseFormSetError<T>,
  fields: Partial<Record<string, Path<T>>>,
): boolean {
  if (!(err instanceof ApiClientError)) return false;
  const status = err.axiosError?.response?.status;
  const data = err.axiosError?.response?.data as
    | { errors?: Record<string, string[] | string> }
    | undefined;
  if (status !== 422) return false;
  if (!data?.errors || typeof data.errors !== 'object') return false;

  let isEveryErrorShown = true;
  Object.entries(data.errors).forEach(([key, messages]) => {
    const field = fields[key] ?? fields[key.split('.')[0]];
    if (!field) {
      isEveryErrorShown = false;
      return;
    }
    const message = Array.isArray(messages) ? messages[0] : String(messages);
    setError(field, { type: 'server', message });
  });
  return isEveryErrorShown;
}
